<template>
  <div class="container-view">
    <Breadcrumbs/>
    <div class="row col-12 container-titles" style="display: flex">
      <div class="header-title col-10">Temática: {{ dataTematica.name }}</div>
      <div class="col-2" style="padding-top: 24px; align-items: flex-end">
        <q-btn
          data-cy="save-tematica"
          style="width: 100%; margin-left: 0 !important"
          color="primary"
          label="Guardar"
          icon="save"
          @click="isNew ? emitNew() : emitgeneralSave()"
          :loading="isLoadingButton"
        />
      </div>
    </div>
    <div>
      <Edicion :dataTematica="dataTematica" :dataVerticales="dataVerticales" :isNew="isNew" @created="isCreate" />
    </div>
    <div class="row col-12">
      <div class="col-12" id="group-container">
        <Servicios
          :dataGrupo="dataTematica"
          :dataServ="servsTematica"
          :arrayServs="arrayServs"
          :isLoadingServs="isLoadingServs"
          :isNew="isNew"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Edicion from '../components/Edicion.vue';
import Servicios from '../components/Servicios.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  components: {
    Edicion,
    Servicios,
    Breadcrumbs
  },
  mixins: [Message, Validation, Loading, Resources],
  data: function () {
    return {
      data: [],
      isLoading: false,
      isLoadingServs: false,
      dataTematica: {},
      dataVerticales: [],
      servsTematica: [],
      arrayServs: [],
      isNew: false,
      isLoadingButton: false,
      checkSave: {
        isInfoSave: null,
        isServSave: null,
        existError: false
      },
      events: {
        saveNewTematica: 'EJECUCION_NUEVO',
        saveTematica: 'ACTUALIZAR_INFORMACION',
        saveLogotipo: 'EJECUCION_GUARDAR_LOGOTIPO',
        saveVideo: 'EJECUCION_GUARDAR_VIDEO',
        saveServicios: 'EJECUCION_GUARDAR_SERVS'
      }
    };
  },
  async created () {
    let idTematica = this.$route.params.idTematica ? this.$route.params.idTematica : null;

    if (idTematica !== null) {
      await this._callData(idTematica);
    } else {
      this.isNew = true;
    }

    await this._getServs();
    await this._getVerticals();
  },
  methods: {
    async emitNew () {
      this.resetSaved();
      await this.$eventHub.$emit(this.events.saveNewTematica, {
        callback: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.dataTematica.id = x.data.id;
          this.$eventHub.$emit(this.events.saveServicios, {
            callback: (x) => {
              this.checkSave.isServSave = x.status;
              this.checkSaved();

              this.isNew = false;
              // Change Page
              this.$router.push({
                name: 'form_tematica',
                params: { idTematica: this.dataTematica.id }
              });
            }
          });
        },
        rejected: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    async emitgeneralSave () {
      // Reset variables
      this.resetSaved();

      await this.$eventHub.$emit(this.events.saveTematica, {
        callback: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();

          this.$eventHub.$emit(this.events.saveVideo, {
            callback: (x) => {}, rejected: (x) => {}
          });

          this.$eventHub.$emit(this.events.saveLogotipo, {
            callback: (x) => {}, rejected: (x) => {}
          });

          this.$eventHub.$emit(this.events.saveServicios, {
            callback: (x) => {
              this.checkSave.isServSave = x.status;
              this.checkSaved();
            }
          });
        },
        rejected: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    resetSaved () {
      this.isLoadingButton = true;
      this.checkSave.existError = false;
      this.checkSave.isInfoSave = null;
      this.checkSave.isServSave = null;
    },
    checkSaved () {
      if (
        this.checkSave.isInfoSave &&
        this.checkSave.isServSave
      ) {
        this.showMessage('Datos guardados con éxito.');
        // Stop Loading Button
        this.isLoadingButton = false;
      } else if (
        (this.checkSave.isInfoSave === false ||
          this.checkSave.isServSave === false) &&
        this.checkSave.existError === false
      ) {
        this.checkSave.existError = true;
        this.showError('No se han podido guardar los datos.');
        // Stop Loading Button
        this.isLoadingButton = false;
      }
    },
    async isCreate (val) {
      this.isNew = false;
      await this._callData(val);
    },
    async _callData (idTematica) {
      this.isLoading = true;
      this.showLoading();

      let request = {
        controller: '/Tematica/' + idTematica
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(async (response) => {
          let data = response.data;
          data.id = idTematica;
          data.resources = await this.getResources('Temática', idTematica);
          this.dataTematica = data;

          this.servsTematica = this.dataTematica.servicios;

          this.isLoading = false;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.isLoading = false;
          this.hideLoading();
        });
    },
    async _getServs () {
      this.isLoadingServs = true;
      this.showLoading();
      let request = {
        controller: '/Servicio'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.arrayServs = response.data;
          this.isLoadingServs = false;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.isLoadingServs = false;
          this.hideLoading();
        });
    },
    async _getVerticals () {
      this.showLoading();

      let request = {
        controller: '/Vertical'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.dataVerticales = response.data;

          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  .txt-return {
    padding-left: 8px;
    object-fit: contain;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.36px;
    text-align: center;
    color: $azulcabecera;
    font-family: "DINPro";
  }
}

#group-container {
  padding-top: 32px;
}
</style>
